import React, { useContext } from 'react';
import classNames from './NotificationsBadge.module.scss';
import { NotificationsContext } from '@/context/NotificationsContext';
import { createAnchorWrapper } from '@/components/school-management/Anchor/Anchor';
import SVG from 'react-inlinesvg';
import bellIcon from '@/assets/svg/bell.svg';
import NotificationsList from '@/components/Notifications/NotificationsList/NotificationsList';

const ButtonAnchor = createAnchorWrapper('button');

interface NotificationsBadgeProps {}

const NotificationsBadge = ({}: NotificationsBadgeProps) => {
  const { numberOfUnreadNotifications } = useContext(NotificationsContext);

  return (
    <ButtonAnchor
      className={classNames.button}
      trigerType='click'
      autoClose={true}
      stayInView={true}
      tooltip={
        <div className={classNames.tooltip}>
          <NotificationsList />
        </div>
      }
      renderTooltipPosition={anchorPosition => {
        return {
          top: anchorPosition.top + anchorPosition.height + 5,
          right: anchorPosition.right,
        };
      }}
    >
      <SVG src={bellIcon} />
      {numberOfUnreadNotifications > 0 && <div>{numberOfUnreadNotifications}</div>}
    </ButtonAnchor>
  );
};

export default React.memo(NotificationsBadge);
